const styles = `:host {
  display: flex;
  height: var(--goto-icon-size, 18px);
  pointer-events: none;
}

::slotted(svg),
.resolved-icon {
  color: var(--goto-icon-color, --goto-text-01);
  display: flex;
  height: var(--goto-icon-size, 18px);
  margin: var(--goto-icon-margin, 0);
  user-select: none;
  width: var(--goto-icon-size, 18px);
}

.hidden {
  display: none;
}`; export default styles;